import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const deleteContactFromHashtag = async (connectionID = 0, hashtagID, selectedContacts) => {
  const apiURL = API_HOST + '/contact_hashtags_connections/' + connectionID;
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.delete(apiURL,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
      },
      data:{
        hashtag_id: hashtagID,
        contacts: selectedContacts,
      }
    });
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
